import { Component, signal } from "@angular/core";
import { CapitalContainer } from "@commons/capital-container/capital-container";
import { CapitalBack } from "@commons/capital-back/capital-back";
import { HomeOptionsElement } from "./home-options-element/home-options-element";
import { AuthService } from "@commons/services/auth.service";
import { CertificadosService } from "@commons/services/certificados.service";

@Component({
  selector: 'app-home-options',
  imports: [CapitalContainer, CapitalBack, HomeOptionsElement],
  templateUrl: './home-options.html',
  styleUrl: './home-options.scss',
})
export class HomeOptions {
  isLoggingOut = signal<boolean>(false);

  constructor(
    public authService: AuthService,
    public certificadosService: CertificadosService
  ) {}

  async onLogout() {
    this.isLoggingOut.set(true);
    try {
      await this.authService.logout();
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    } finally {
      this.isLoggingOut.set(false);
    }
  }
}
